export default "__VITE_ASSET__$LMUy7ZL__"